
export async function updateTest( testId, data ) {

  let url = '/api/tests/' + testId
  console.log( url )
  console.log( data  )
  return await $axios.put( url, data ).then( response => {
    console.log( response.data )
    return response.data
  }).catch( error => {
    console.log("error")
    console.log(error)
    return error
  })
}

export async function pauseTest( testId ) {

  let data = {
    action : 'pause',
  }
  let url = '/api/tests/' + testId
  console.log( url )
  console.log( data  )
  return await $axios.put( url, data ).then( response => {
    console.log( response.data )
    return response.data
  }).catch( error => {
    console.log("error")
    console.log(error)
    return error
  })
}
